import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { pathRoutingEnum } from 'src/assets/constantEnum';
import { ConsentService } from '../services/consent.service';
import { SocialLinksService } from '../services/social-links.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor(private router: Router, private consentService: ConsentService, private socialLinks: SocialLinksService) { }

  // « Rejoignez-nous » : réseaux dont la page est renseignée dans le back office
  get socialLinks$() {
    return this.socialLinks.links$;
  }

  ngOnInit(): void {
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }

  year = new Date().getFullYear();

  onGoDashboard (){
    this.router.navigate([pathRoutingEnum.dashboard.valueOf()]);
  }

  showCookieDialog() {
    this.consentService.openPreferences();
  }

}
